import { Component } from '@angular/core';

@Component({
  selector: 'quotely-header',
  templateUrl: './header.component.html',
})
export class HeaderComponent {
}
